import * as React from "react";
import DefaultMapPage from "../../../common/DefaulMapPage/DefaultMapPage";

const RealEstateGlobally = () => (
  <>
    <DefaultMapPage title='Real Estate Globally'
                    subtitle='scroll'
                    pageInfo='01 - hello'
                    isScroll={true}/>
  </>

);

export default RealEstateGlobally;
